{
  "Dashboard": "Dashboard",
  "BlyCareShippingProte": "BlyCare Shipping protection",
  "LoadingBlyCare": "Loading BlyCare…",
  "LoadingWidgetSetting": "Loading widget settings…",
  "PreparingYourWorkspa": "Preparing your workspace",
  "Language": "Language",
  "English": "English",
  "EnglishDefault": "English (Default)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Setup guide",
  "CompletedOfTotalComp": "{{completed}} of {{total}} completed",
  "Dismiss": "Dismiss",
  "MoreActions": "More actions",
  "ToggleSetupGuide": "Toggle setup guide",
  "ActivateAppEmbed": "Activate app embed",
  "ClickTheEnableButton": "1. Click the Enable button below to open your Shopify theme editor.",
  "BlyCareEmbedSection": "2. Look for BlyCare in the App embed section on the left. Make sure its toggle is switched on. Then click Save in the top right corner.",
  "Enable": "Enable",
  "PublishWidget": "Publish widget",
  "PublishStorefront": "Publish widget on your storefront, available for customer to purchase.",
  "Publish": "Publish",
  "SetProtectionFee": "Set protection fee",
  "FeeYouWantToCharge": "Set the fee you want to charge customers.",
  "Setup": "Set up",
  "TestYourWidgetOnYour": "Test your widget on your store",
  "AddAProductToYourCar": "Add a product to your cart and check that the shipping protection widget appears. Select shipping protection, then continue to checkout and make sure the shipping protection product is included in checkout page.",
  "TestNow": "Test now",
  "Working": "Working",
  "NeedHelp": "Need help",
  "MarkAsCompleted": "Mark as completed",
  "AppStatus": "App status",
  "AppEmbed": "App embed",
  "EnableAppEmbedToDisp": "Enable app embed to display shipping protection on cart.",
  "CartPage": "Display shipping protection on cart page.",
  "CheckoutBlock": "Checkout block",
  "CheckoutPage": "Display shipping protection on checkout page.",
  "Active": "Active",
  "Inactive": "Inactive",
  "Analytics": "Analytics",
  "Today": "Today",
  "Last7Days": "Last 7 days",
  "Last30Days": "Last 30 days",
  "Last60Days": "Last 60 days",
  "Last90Days": "Last 90 days",
  "Last365Days": "Last 365 days",
  "Custom": "Custom",
  "Start": "Start",
  "End": "End",
  "DateRange": "Date range",
  "SelectedRange": "Selected range: {{range}}",
  "Cancel": "Cancel",
  "Save": "Save",
  "ChooseAStartDateOnOr": "Choose a start date on or before the end date, and do not pick a day after today.",
  "PreviousMonth": "Previous month",
  "NextMonth": "Next month",
  "ProtectionRevenue": "Protection revenue",
  "ProtectedOrders": "Protected orders",
  "ProtectedOrderRate": "Protected order rate",
  "LoadingAnalytics": "Loading analytics…",
  "AnalyticsCouldNotLo": "Analytics could not load",
  "RetryAnalytics": "Retry analytics",
  "Resources": "Resources",
  "HowDoesShippingProte": "How does shipping protection work?",
  "BlyCareAddsAShipping": "BlyCare adds a shipping protection widget to your cart. Customers can choose to add protection for their orders. Merchant collecting the protection fee, decides what situations are covered, and uses those fees to resolve claims.",
  "DoesBlyCareCoverInsu": "Does BlyCare cover insurance claims?",
  "NoBlyCareIsNotInsura": "No. BlyCare is not insurance and does not pay for claims. BlyCare only provides the widget and tools for merchants to manage their own shipping protection program.",
  "EmailUs": "Email us",
  "LiveChat": "Live chat",
  "HelpCenter": "Help center",
  "Settings": "Settings",
  "CheckoutWidget": "Checkout widget",
  "CartWidget": "Cart widget",
  "PriceSetting": "Price setting",
  "ProductSetting": "Product setting",
  "AdminLanguage": "Admin Language",
  "AdminLanguageTitle": "Admin language",
  "AdminLanguageHelp": "Changes the app language for you only. Customers aren't affected.",
  "AppLanguage": "App Language",
  "UnableToLoadSettings": "Unable to load settings",
  "TryAgain": "Try again",
  "Discard": "Discard",
  "LoadingSettings": "Loading settings",
  "PageNotFound": "Page not found",
  "ProductSettingsCould": "Product settings could not be saved.",
  "Fulfillment": "Fulfillment",
  "FulfillmentHelp": "Choose when the protection product is marked as fulfilled.",
  "ManuallyFulfill": "Manually fulfill",
  "MarkFulfilledWhenFir": "Mark fulfilled when first item in the order is fulfilled",
  "MarkFulfilledWhenAll": "Mark fulfilled when all other items in the order are fulfilled",
  "MarkFulfilledImmedi": "Mark fulfilled immediately after order creation",
  "Exclusions": "Exclusions",
  "ExclusionsHelp": "Choose when protection shouldn't apply.",
  "ExclusionType": "Exclusion type",
  "Select": "Select",
  "SelectedExclusions": "Selected exclusions",
  "RemoveName": "Remove {{name}}",
  "WhenExcluded": "When excluded",
  "HideWidget": "Hide widget",
  "KeepWidgetButSkipThe": "Keep widget but skip the fee",
  "ExcludeProductType": "Exclude product type",
  "SearchProductType": "Search product type",
  "ExcludeSKU": "Exclude SKU",
  "SearchSKU": "Search SKU",
  "ExcludeCollection": "Exclude collection",
  "SearchCollection": "Search collection",
  "ExcludeMarket": "Exclude market",
  "SearchMarket": "Search market",
  "ExcludeLanguage": "Exclude language",
  "SearchLanguage": "Search language",
  "Add": "Add",
  "PriceSettingsCouldNo": "Price settings could not be saved.",
  "ShippingProtectionPr": "Shipping protection price",
  "SetHowMuchPriceDoYou": "Set how much price do you charge your customer",
  "PricingMethod": "Pricing method",
  "Fixed": "Fixed",
  "Percentage": "Percentage",
  "UniversalProtectionP": "Universal protection price",
  "PercentageOfCartSubt": "Percentage of cart subtotal",
  "EditCappedPrice": "Edit capped price",
  "ShippingProtectionFe": "Shipping protection fee by percentage ranged from {{minPrice}} USD, increasing from {{increment}} USD, capped at {{capped}} USD.",
  "MinProtectionFee": "Min protection fee",
  "IncrementAmount": "Increment amount",
  "CappedProtectionFee": "Capped protection fee",
  "AddTierPrice": "Add tier price",
  "AddTier": "Add tier",
  "TierPriceHelp": "If cart price does not match any of your tier cart price range, the universal price you set on the previous page will take place.",
  "MinCartPrice": "Min cart price",
  "MaxCartPrice": "Max cart price",
  "ProtectionFee": "Protection fee",
  "RemoveTier": "Remove tier",
  "Required": "Required",
  "ThisFieldIsRequired": "This field is required.",
  "MustBeGreaterThanZero": "{{label}} must be greater than 0.",
  "MustBeOrLess": "{{label}} must be {{max}} or less.",
  "AtMostTwoDecimals": "{{label}} can have at most 2 decimals.",
  "MustBeLargerThanMinC": "Must be larger than min cart price",
  "MustBeLargerThanMaxC": "Must be larger than max cart price",
  "MustBeSmallerThanMin": "Must be smaller than min cart price",
  "Price": "Price",
  "MinimumPrice": "Minimum price",
  "Increment": "Increment",
  "CartPageWidget": "Cart page widget",
  "CheckoutPageWidget": "Checkout page widget",
  "WidgetFormat": "Widget format",
  "TickerWidget": "Ticker widget",
  "CheckoutButtonWidget": "Checkout button widget",
  "Text": "Text",
  "MainText": "Main text",
  "Title": "Title",
  "Description": "Description",
  "MainButtonText": "Main button text",
  "SecondaryButtonText": "Secondary button text",
  "EnabledDescription": "Enabled description",
  "DisabledDescription": "Disabled description",
  "PleaseEnterTitle": "Please enter title",
  "PleaseEnterDescript": "Please enter description",
  "PleaseEnterMainButt": "Please enter main button text",
  "PleaseEnterSecondar": "Please enter secondary button text",
  "PleaseEnterEnabledD": "Please enter enabled description",
  "PleaseEnterDisabled": "Please enter disabled description",
  "EGViewTerms": "e.g. View terms",
  "EGHttpTerms": "e.g. https://terms.com",
  "Footer": "Footer",
  "FooterText": "Footer text",
  "FooterLink": "Footer link",
  "TooltipLink": "Tooltip link",
  "FooterVisibility": "Footer visibility",
  "TitleInfoVisibility": "Title info visibility",
  "Disabled": "Disabled",
  "Enabled": "Enabled",
  "Color": "Color",
  "ColorStyle": "Color style",
  "SizeAndDisplay": "Size and display",
  "IconSize": "Icon size",
  "IconRadius": "Icon radius",
  "BorderSize": "Border size",
  "BorderRadius": "Border radius",
  "HorizontalPadding": "Horizontal padding",
  "VerticalPadding": "Vertical padding",
  "ToggleFormat": "Toggle format",
  "Switch": "Switch",
  "Checkbox": "Checkbox",
  "Border": "Border",
  "Background": "Background",
  "ProtectionDescript": "Protection description",
  "MainButtonBackgrou": "Main button background",
  "EnabledToggle": "Enabled toggle",
  "DisabledToggle": "Disabled toggle",
  "Automatic": "Automatic",
  "Neutral": "Neutral",
  "Info": "Info",
  "Success": "Success",
  "Warning": "Warning",
  "Critical": "Critical",
  "Subdued": "Subdued",
  "Transparent": "Transparent",
  "ThemeColor": "Theme color",
  "ResetToDefaultColor": "{{label}}: reset to the default color",
  "OpenColorPicker": "{{label}}: open color picker",
  "Icon": "Icon",
  "PackageIcon": "Package icon",
  "PackageIconNumber": "Package icon {{value}}",
  "UploadIcon": "Upload icon",
  "NoIcon": "No icon",
  "AcceptedFormats": "Accepted formats: PNG, JPG, SVG",
  "MaximumFileSize": "Maximum file size: 50 MB",
  "AddFiles": "Add files",
  "RemoveImage": "Remove image",
  "Uploading": "Uploading",
  "UploadFailedTryAgain": "Upload failed. Try again.",
  "ChooseAJPEGPNG": "Choose a JPEG, PNG or SVG image up to 50 MB.",
  "ChooseNonemptyImage": "Choose a nonempty JPEG, JPG, PNG or SVG image up to 50 MB.",
  "ImageCouldNotBeRead": "The image could not be read.",
  "FileContentsMismatch": "The file contents must match its JPEG, PNG or SVG image type.",
  "ImageCouldNotBeDecode": "The image could not be decoded.",
  "InvalidImageUrl": "The upload service returned an invalid image URL.",
  "MissingPublicImageUrl": "The upload service did not return a public image URL.",
  "CustomCssTooLong": "Custom CSS must be at most 2,000 characters.",
  "ChooseValidIconUrl": "Choose an uploaded icon with a valid URL.",
  "EnterNumberRange": "Enter a number from {{min}} to {{max}}.",
  "EnterLocaleTextRange": "Enter {{locale}} text between 1 and {{limit}} characters.",
  "EnterValidLearnMoreUrl": "Enter a valid Learn more URL beginning with https:// or http://.",
  "ReviewHighlightedFields": "Review the highlighted fields.",
  "CannotChangePublishState": "Cannot change the publish state until the form is valid: {{reason}}",
  "BlyCareCouldNotSave": "BlyCare could not save.",
  "CheckoutRequiresPlus": "Checkout customization requires Shopify Plus.",
  "SaveSucceededReloadFailed": "The save request succeeded, but the latest widget settings could not be loaded. Refresh to verify your changes.",
  "BlyCareCouldNotComplete": "BlyCare could not complete this request.",
  "ShopifyAuthorizationRequired": "Shopify authorization is required.",
  "AppBridgeUnavailable": "Shopify App Bridge is unavailable",
  "ExtensionStatusUnavailable": "Shopify extension status is unavailable.",
  "ConfigurationPreview": "Configuration preview",
  "On": "On",
  "Off": "Off",
  "Unpublish": "Unpublish",
  "AppEmbedIsNotEnable": "App embed is not enabled.",
  "GoEnabled": "Go enabled",
  "ViewOnYourStorefront": "View on your storefront",
  "PreviewProtection": "Preview protection",
  "MoreInformation": "More information",
  "Cart": "Cart",
  "Subtotal": "Subtotal",
  "Checkout": "Checkout",
  "DiscountCode": "Discount code",
  "Apply": "Apply",
  "Shipping": "Shipping",
  "Total": "Total",
  "ShippingProtection": "Shipping protection",
  "Product": "Product",
  "CopyLink": "Copy link"
}
